import { AdminCompanyResponseDtoTypeEnum } from "shared/api";
import { AvailableFieldName } from "./enums";
import { isAfter, isBefore, isLessThan, isMoreThan, isNotEmpty, isValidDate, isValidEmail, isValidNumber } from "./validators";
import { FieldDescriptorsByCompanyType } from "./types";

const nowDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
const yearLaterDate = new Date(nowDate.getFullYear() + 1, nowDate.getMonth(), nowDate.getDate());

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const FieldDescriptorsByCompany: FieldDescriptorsByCompanyType = {
  [AdminCompanyResponseDtoTypeEnum.Balance]: [
    { name: AvailableFieldName.Email, validators: [isNotEmpty, isValidEmail], isRequired: true, formatValue: (value) => value.toLowerCase().trim() },
    { name: AvailableFieldName.Role, validators: [isNotEmpty], isRequired: true, formatValue: (value) => value.toLowerCase().trim() },
    { name: AvailableFieldName.Group, validators: [], isRequired: false, formatValue: (value) => value ? value.toLowerCase().trim() : undefined },
    { name: AvailableFieldName.Balance, validators: [isValidNumber, isMoreThan(1), isLessThan(10)], isRequired: true, formatValue: (value) => Number(value) },
    { name: AvailableFieldName.BalanceStartWith, validators: [isNotEmpty, isValidDate, isAfter(nowDate), isBefore(yearLaterDate)], isRequired: true, formatValue: (value) => value.trim() },
    { name: AvailableFieldName.BalanceEndWith, validators: [isNotEmpty, isValidDate, isAfter(nowDate), isBefore(yearLaterDate)], isRequired: true, formatValue: (value) => value.trim() },
  ],
  [AdminCompanyResponseDtoTypeEnum.Promocode]: [
    { name: AvailableFieldName.Email, validators: [isNotEmpty, isValidEmail], isRequired: true, formatValue: (value) => value.toLowerCase().trim() },
    { name: AvailableFieldName.Role, validators: [isNotEmpty], isRequired: true, formatValue: (value) => value.toLowerCase().trim() },
    { name: AvailableFieldName.Group, validators: [], isRequired: false, formatValue: (value) => value ? value.toLowerCase().trim() : undefined },
    { name: AvailableFieldName.Quantity, validators: [isValidNumber, isMoreThan(1), isLessThan(10)], isRequired: true, formatValue: (value) => Number(value) },
    { name: AvailableFieldName.Amount, validators: [isMoreThan(100), isLessThan(50000)], isRequired: false, formatValue: (value) => value ? Number(value) : undefined },
    { name: AvailableFieldName.Percentage, validators: [isMoreThan(5), isLessThan(100)], isRequired: false, formatValue: (value) => value ? Number(value) : undefined },
    { name: AvailableFieldName.ExpirationDate, validators: [isNotEmpty, isValidDate, isAfter(nowDate), isBefore(yearLaterDate)], isRequired: true, formatValue: (value) => value.trim() },
  ],
}






